import React from 'react';

export const StarIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            version="1.1"
            viewBox="0 0 5.821 5.821"
        >
            <g>
                <path
                    fill="none"
                    fillOpacity="1"
                    stroke="#fff"
                    strokeDasharray="none"
                    strokeMiterlimit="4"
                    strokeOpacity="1"
                    strokeWidth="0.623"
                    d="M4.51 5.268l-1.567-.794-1.543.841.271-1.736L.394 2.372l1.735-.28.754-1.586.801 1.563 1.742.227L4.187 3.54z"
                    transform="matrix(.83059 0 0 .86947 .496 .434)"
                ></path>
            </g>
        </svg>
    );
};
